<template>
  <div class="main-continer">
    <nav class="navbar navbar-toggleable-md navbar-light bg-faded navbarzindex navbar-min-height">
        <div :class="windowWidth > 1920 ? 'container-fluid custom-container' : ''" class="row w-100 align-items-center">
            <div class="col-5 d-flex">
                <div class="hamburger-icon">
                    <div class="mt-1" style="height: 100%;" @click="openSideNav()">
                        <img src="./assets/images/hamburger-bleack.svg" alt="Logo" />
                    </div>
                    <SideNav :isOpen="showSideNav" @close="showSideNav = false" :isDesktop="isDesktop"></SideNav>
                </div>
                <div class="container">
                    <div class="nav-list">
                        <div class="">
                            <ul class="top_nav">
                                <!-- <div v-for="(item, index) in navMenus" :key="index">
                                  <li v-if="true" :class="[activeWebCategory === item.name.toLowerCase() ? 'activeCat':'']" @click="handleNavMenu(item)">
                                      <router-link :to="(item.url ? item.url : '#')">{{item.name}} </router-link>
                                  </li>
                                </div> -->
                                <li v-if="true" :class="[webcategory === 'men' ? 'activeCat':'']">
                                    <router-link to="/men">MEN</router-link>
                                </li>
                                <li v-if="true" :class="[webcategory === 'women' ? 'activeCat':'']">
                                    <router-link to="/women">WOMEN</router-link>
                                </li>
                                <li v-if="true" :class="[webcategory === 'kids' ? 'activeCat':'']">
                                    <router-link to="/kids">{{bannerPlaceHolderForSneakersWebCategory.description}}</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-2">
              <div class="icon-container d-flex justify-content-center mt-1">
                <router-link to="/">
                    <div class="icon">
                      <img v-if="isExclusive" src="./assets/images/Member-tss-logo.gif" alt="Logo" />
                      <img style="margin-top: 3px;" v-else src="./assets/images/non-member-logo2.gif" alt="Logo" />
                    </div>
                </router-link>
              </div>
            </div>
            <div class="col-5">
                <div class="right-content">
                    <ul class="navbar-nav">
                        <li class="mr-1">
                            <div class="search-wrapper">
                                <div class="search new-search">
                                    <autocomplete :trigger="trigger" :searchTerm="value" :callerComp="callerComp" :isNewSearch="true"></autocomplete>
                                </div>
                            </div>
                        </li>
                        <!-- Track Order Icon  -->
                        <li class="nav-item navicon track-order">
                          <a class="nav-link dropdown-toggle track-hover" id="navbarDropdownuser" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="trackOrder">
                            <!-- <div class="hover-label">Track</div> -->
                            <span>
                              <img src="./assets/images/trackorder.svg" alt="wishlist" width="28" height="28" />
                            </span>
                            <span class="hover-label">Track Order</span>                          
                          </a>
                        </li>
                        <li class="nav-item navicon dropdown iconlink">
                          <a class="nav-link naviconTitle dropdown-toggle" href="javascript:void(0)" id="navbarDropdownuser"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="gotoUrl('orders')"
                            v-if="authStatus" :title="userAcc.getuserName">
                            <span>
                              <img src="./assets/images/mship-profile.svg" alt="wishlist" width="25" height="25" />
                            </span>
                            <!-- <span v-else class="hicon fa fa-user-o"></span> -->
                            <div class="count" style="top:11px;" v-if="(getPlatformCounts('TSS_MONEY') || getPlatformCounts('TSS_POINTS')) > 0">
                              {{ getPlatformCounts('TSS_MONEY') + getPlatformCounts('TSS_POINTS') }}
                            </div>
                          </a>
                          <span class="nav-link noTdropdown" @click="redirectToLogin" v-else>
                            <span>
                              <img src="./assets/images/mship-profile.svg" alt="wishlist" width="25" height="25" />
                            </span>
                          </span>
                          <div class="dropdown-menu right" aria-labelledby="navbarDropdownuser" v-if="authStatus">
                            <router-link to="/orders" class="dropdown-item '+this.$router.currentRoute+'"><span @click="profileEventsHandler('Orders')">Orders</span></router-link>
                            <router-link to="/my-gift-voucher" v-if="isSelectedCountryIndia" class="dropdown-item"><span @click="profileEventsHandler('Gift Vouchers')">Gift Vouchers</span></router-link>
                            <router-link to="/my-reward-points/money" v-if="isSelectedCountryIndia" class="dropdown-item">
                              <span @click="profileEventsHandler('TSS Money')">
                                TSS Money
                              </span>
                              <span class="badge badge-danger rounded-circle" title="Expiring soon" v-if="getPlatformCounts('TSS_MONEY') > 0">
                                {{ getPlatformCounts('TSS_MONEY') }}
                              </span>
                            </router-link>
                            <router-link to="/my-reward-points/points" v-if="isSelectedCountryIndia" class="dropdown-item">
                              <span @click="profileEventsHandler('TSS Points')">
                                TSS Points
                              </span>
                              <span class="badge badge-danger rounded-circle" title="Expiring soon" v-if="getPlatformCounts('TSS_POINTS') > 0">
                                {{ getPlatformCounts('TSS_POINTS') }}
                              </span>
                            </router-link>
                            <router-link to="/my-saved-cards" v-if="isSelectedCountryIndia" class="dropdown-item"><span @click="profileEventsHandler('Saved Cards')">Saved Cards</span></router-link>
                            <a @click="sideMenu('/profile')" class="dropdown-item pointer profile" :class="this.$route.path === '/profile' ? 'profileactive' : ''"><span>Profile</span></a>
                            <router-link to="/faqs" class="dropdown-item"><span @click="profileEventsHandler('FAQs')">FAQs</span></router-link>
                            <router-link to="/contact-us" class="dropdown-item"><span @click="profileEventsHandler('Contact Us')">Contact Us</span></router-link>
                            <router-link to="/artwork-sale" class="dropdown-item" v-if="user.user_type == 3"><span @click="profileEventsHandler('Artwork Sales')">Artwork Sales</span></router-link>
                            <router-link to="/submit-art-work" class="dropdown-item"><span @click="profileEventsHandler('Submit Design')">Submit Design</span></router-link>
                            <div class="dropdown-item pointer " @click="handlelogout">Logout</div>   
                          </div>
                        </li>
                        <!-- Wishlist Icon  -->
                        <li class="nav-item navicon" v-if="!disableWishlist">
                          <a class="nav-link dropdown-toggle" id="navbarDropdownuser" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="wishlistEvent">
                            <span>
                              <img src="./assets/images/mship-wishlist.svg" alt="wishlist" width="23" height="23" />
                            </span>
                            <!-- <span v-else class="headercart hicon fa" :class="this.$router.currentRoute.path === '/mywishlist' ? 'fa-heart-o active' : 'fa-heart-o'"></span> -->
                            
                            <div class="count" style="top:8px;" v-if="wishlistCount > 0">{{ wishlistCount || wishlistLength }}</div>
                            <div class="count" style="top:8px;" v-else-if="wishlistLength > 0">{{ wishlistLength }}</div>
                          </a>
                        </li>
                          <!-- Cart Icon  -->
                        <li class="nav-item navicon">
                          <a class="nav-link dropdown-toggle" id="navbarDropdownuser" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="cartEvent">
                            <span>
                              <img src="./assets/images/shopping-cart.svg" alt="Cart" width="25" height="25" class="headercart" />
                            </span>
                            <div v-if="cartcount>0" class="count" style="top:11px;">{{isMystery ? cartcount - 1 : cartcount }}</div>
                            <div v-else-if="cartLength>0" class="count" style="top:11px;">{{isMystery ? cartLength - 1 : cartLength }}</div>
                          </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
  </div>
</template>
<script>
var $ = require('jquery')
window.jQuery = $
import auth from './auth/index.js'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import SideNav from './sideNav.vue'
import store from './store/index'
const autocomplete = () => import('./components/common/autocomplete')
export default {
  name: 'navbar',
  components: {
    SideNav,
    autocomplete
  },
  data () {
    return {
      showSideNav: false,
      trigger: false,
      value: store.getters.getSearchKey,
      userAcc: auth.user,
      windowWidth: '',
      ckAuth: auth,
      searchTerm: '',
      oTrack: false,
      count: 0,
      catImgPath: process.env.IMG_BASE_URL + process.env.CATEGORY_IMG,
      products: [],
      exclusiveEnabled: process.env.EXCLUSIVE_ENABLED,
      womenApparels: "WOMEN'S APPARELS",
      columnLength: 5,
      imgBaseUrl: process.env.STATIC_IMG_SERVER2
    }
  },
  props: ['callerComp', 'landingPageMenuData', 'handleMenu', 'isDesktop'],
  computed: {
    ...mapGetters({
      webcategory: 'webcategory',
      isSelectedCountryIndia: 'isSelectedCountryIndia',
      isExclusive: 'isExclusive',
      user: 'user',
      authStatus: 'authStatus',
      wishlistCount: 'wishlistCount',
      cartcount: 'cartcount',
      isMystery: 'isMystery',
      disableWishlist: 'disableWishlist',
      confirmedLogout: 'confirmedLogout',
      navMenus: 'navMenus',
      activeWebCategory: 'activeWebCategory',
      getGlobalSettingKeys: 'getGlobalSettingKeys',
      isComboActive: 'isComboActive',
      hasAddressChanged: 'hasAddressChanged',
      loginModel: 'loginModelBox',
      loading: 'loading',
      _products: 'FETCH_PRODUCTS',
      exclusiveUser: 'exclusiveUser',
      navMenuData: 'navMenuData',
      bannerPlcaeHolderData: 'bannerPlcaeHolderData',
      supimaLandingData: 'supimaLandingData',
      isBirthdayMonth: 'isBirthdayMonth',
      notificationData: 'notificationData',
      isPosLogin: 'isPosLogin',
      isCodCheckoutLogin: 'isCodCheckoutLogin',
      globalBannerPlaceholder: 'globalBannerPlaceholder',
      moengageImpressionData: 'moengageImpressionData',
      countries: 'countries',
      country_detail_data: 'country_detail_data',
      cartLength: 'cartLength',
      wishlistLength: 'wishlistLength'
    }),
    menuData () {
      if (this.landingPageMenuData) {
        return this.landingPageMenuData
      } else if (this.isComboActive && !(this.callerComp === 'supimaSubMenu' || this.callerComp === 'activeWearSubMenu')) {
        return this.genderSpecificNavData
      }
      return this.navMenuData
    },
    genderSpecificNavData () {
      let genderData
      if (this.webcategory === 'women') {
        genderData = this.navMenuData && this.navMenuData.find((itm) => itm.name === 'Women')
      } else if (this.webcategory === 'kids') {
        genderData = this.navMenuData && this.navMenuData.find((itm) => itm.name === 'Kids')
      } else {
        genderData = this.navMenuData && this.navMenuData.find((itm) => itm.name === 'Men')
      }
      return genderData && genderData.categories && [...genderData.categories, ...this.otherMenuNavData]
    },
    otherMenuNavData () {
      if (this.webcategory === 'kids') {
        return this.navMenuData && this.navMenuData.filter((itm) => itm.name !== 'Men' && itm.name !== 'Women' && itm.name !== 'Kids' && itm.name !== 'Supima Landing' && itm.name !== 'Activewear')
      }
      return this.navMenuData && this.navMenuData.filter((itm) => itm.name !== 'Men' && itm.name !== 'Women' && itm.name !== 'Kids')
    },
    bannerPlaceHolderForSneakersWebCategory: function () {
      return this.bannerPlcaeHolderData &&
        this.bannerPlcaeHolderData.length &&
        this.bannerPlcaeHolderData.find(bannerData =>
          (bannerData.placeholder_for || '').toLowerCase() === 'pdp screen' &&
          bannerData.status === true &&
          (bannerData.product_type || '').toLowerCase() === 'enable_sneaker_tab_web'
        )
    },
    bannerPlaceHolderForKidsWebCategory: function () {
      return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
        bannerData.product_type.toLowerCase() === 'SHOW_KIDSWEAR_WEBCATEGORY_WEB'.toLowerCase())
    },
    bannerPlaceHolderForGoForAppOnlySale: function () {
      return this.bannerPlcaeHolderData && this.bannerPlcaeHolderData.length && this.bannerPlcaeHolderData.find(bannerData =>
        bannerData.placeholder_for.toLowerCase() === 'Others'.toLowerCase() && bannerData.status === true &&
        bannerData.product_type.toLowerCase() === 'GO_APP_ONLY_SALE_WEB'.toLowerCase())
    },
    showWomenWebMenu: function () {
      return this.isSelectedCountryIndia ? true : this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_WEB_MENU_WOMEN')
    },
    showMenWebMenu: function () {
      return this.isSelectedCountryIndia ? true : this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_WEB_MENU_MEN')
    },
    showKidsWebMenu: function () {
      return this.isSelectedCountryIndia ? true : this.globalBannerPlaceholder && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_WEB_MENU_KIDS')
    },
    showPartialCart: function () {
      return this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.length && this.globalBannerPlaceholder.find(bannerData => bannerData.is_active === true && bannerData.config_key === 'SHOW_PARTIAL_CART')
    }
  },
  mounted () {
    window.addEventListener('resize', this.updateWindowWidth)
    this.ckAuth.checkAuth()
    this.products = this._products
    if (this.authStatus) {
      this.$store.dispatch('GET_NOTIFICATIONS')
    }
  },
  watch: {
    confirmedLogout (newVal) {
      if (newVal) {
        this.weblogout()
        this.$store.dispatch('RESET_CONFIRMED_LOGOUT')
      }
    },
    hasAddressChanged: {
      handler: function () {
        Vue.ls.set('listing_meta_info', null)
        this.$set(this.$parent, 'loading', true)
        this.$store.dispatch('GET_HOME_SCREEN_DATA', {isComboActive: this.isComboActive})
        this.$store.dispatch('GET_NAVMENU_DATA')
        this.$store.dispatch('CART_DATA')
        this.$store.dispatch('WISHLIST_DATA')
        const countryId = this.$store.state.selectedCountryAddress.countryId
        const configKeys = this.getGlobalSettingKeys
        this.$store.dispatch('GLOBAL_GET_BANNERS_DATA', { countryId, configKeys })
      },
      deep: true
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateWindowWidth)
  },
  methods: {
    updateWindowWidth: function () {
      this.windowWidth = window.innerWidth
      this.$forceUpdate()
    },
    openSideNav () {
      this.showSideNav = true
      this.$store.commit('GTAG_EVENT', {eventName: 'CLICK_ON_HAMBURGER',
        payload: {
          openSideNave: this.showSideNav,
          User_ID: this.user.user_id || 'NA',
          Platform: 'WEB'
        }
      })
    },
    hideMenuByPage (pageName) {
      return 'd-none'
    },
    handleSearch (value) {
      this.value = value
    },
    gotoUrl (url) {
      this.$store.commit('GTAG_EVENT', {eventName: 'HEADER_PROFILE', payload: {}})
      this.$router.push('/' + url)
    },
    redirectToLogin () {
      this.$store.dispatch('TATVIC_EVENT', {eventName: 'HEADER_PROFILE', payload: {}})
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    profileEventsHandler (headerText) {
      headerText && headerText !== 'Logout' ? this.$store.dispatch('TATVIC_EVENT', {eventName: 'MY_ACCOUNT_INTERACTIONS',
        payload: {
          INTERACTION_MENU: headerText,
          INTERACTION_TYPE: 'Tray'
        }}
      ) : ''
      headerText && headerText === 'Logout' ? this.$store.dispatch('TATVIC_EVENT', {eventName: 'LOGOUT', payload: {INTERACTION_TYPE: 'Tray', USER_ID: 'NA'}}) : ''
    },
    sideMenu: function (link) {
      this.profileEventsHandler('Profile')
      if (link === '/profile') {
        this.$store.commit('GTAG_EVENT', {eventName: 'profile', payload: {route: Vue.ls.get('routeObj')}})
        this.$router.push(link)
      }
    },
    handlelogout: function () {
      this.$store.dispatch('OPEN_LOGOUT_MODAL')
    },
    wishlistEvent: function () {
      const routeObj = Vue.ls.get('routeObj')
      this.$store.commit('GTAG_EVENT', {eventName: `myWishlist_pageview`, payload: {visitFrom: Vue.ls.get('routeObj').current}})
      this.$store.dispatch('TATVIC_EVENT', {eventName: 'WISHLIST_REDIRECTION_CLICK',
        payload: {
          INTERACTION_TYPE: 'Icon Click'
        }
      })
      this.$store.commit('MOENGAGE_EVENT', {eventName: 'VIEW_WISHLIST',
        payload: {
          ...this.moengageImpressionData,
          Source: String(routeObj && routeObj.current)
        }}
        )
      this.$router.push({ name: 'mywishlist' })
    },
    trackOrder: function () {
      this.$store.commit('GTAG_EVENT', {eventName: 'TRACK_ORDER_CLICK', payload: {visitFrom: Vue.ls.get('routeObj').current}})
      this.$store.dispatch('TATVIC_EVENT', {eventName: 'TRACK_ORDER_CLICK',
        payload: {
          INTERACTION_TYPE: 'Icon Click',
          User_ID: this.user.user_id || 'NA',
          Platform: 'WEB'
        }
      })
      this.$router.push('/orders')
    },
    cartEvent: function () {
      this.cartIconEventHandler()
      this.$router.push({ name: 'cart' })
    },
    cartIconEventHandler () {
      this.$store.commit('GTAG_EVENT', {eventName: 'CART_ICON_CLICK', payload: {}})
    },
    weblogout () {
      this.profileEventsHandler('Logout')
      this.logout()
      this.$store.dispatch('CLOSE_LOGOUT_MODAL')
      window.HaptikSDK.logout(function () {
        console.log('logout')
      })
    },
    logout () {
      // auth.logout(this, '/')
      this.$store.dispatch('BLACKLIST_LOGOUT').then(res => {
        this.$store.dispatch('LOGOUT', {
          requiresAuth: this.$route.meta.requiresAuth
        }).then(response => {
          this.$toasted.show((res && res.message) || 'You have been successfully logged out', {
            theme: 'primary',
            className: 'toasted-customred',
            position: 'top-right',
            duration: 5000
          })
          this.$store.dispatch('CART_DATA')
          this.$store.dispatch('WISHLIST_DATA')
          this.$store.state.auth.phoneNumber = ''
        })
      })
    },
    getPlatformCounts (str) {
      let counts = 0
      this.notificationData && this.notificationData.forEach(element => {
        if (element.platform === str) {
          counts = element.counts
        }
      })
      return counts
    },
    handleNavMenu (item) {
      this.$store.commit('SET_ACTIVE_WEB_CATEGORY', item.name.toLowerCase())
      Vue.ls.set('active_webnavcategory', item)
      // this.$router.push({ name: item.name.toLowerCase() })
    }
  }
}
</script>
<style lang="css" scoped>

    .hamburger-icon {
        width: 50px;
        margin-left: 37px;
        cursor: pointer;
    }
    .nav-list {
        margin-left: -20px;
    }
   .top_nav {
        display: flex;
        margin: 0 0px;

        li {
            list-style: none;
            margin-right: 25px;
            font-size: 16px;
            font-weight: 500;
            min-width: 58px;
            text-align: center;
            max-width: 150px;
        }
        a {
            font-family: "Source Sans Pro";
            font-size: 20px;
            /* color: #222;
            font-style: normal;
            font-weight: 500;
            line-height: normal; */
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.24;
            letter-spacing: normal;
            text-align: center;
            color: #292b2c;
            text-transform: uppercase;
            margin: 0;
        }
        .activeCat {
            border-bottom: 2px solid #FC2020;
            padding-bottom: 6px;
            line-height: 1.5;
        }
    }
  .navbarzindex {
    z-index: 101 !important; 
    /* higher z-index than play/pause button of videoplayer component */
  }
  .navbar-min-height {
    min-height: 70px
  }
  .icon {
    width: 85px;
    height: 65px;
  }

  .search-wrapper {
    margin: 10px auto;
    height: 42px;
    margin-right: 10px;
    cursor: pointer;
  }
  .new-search {
    vertical-align: middle;
    white-space: nowrap;
    position: relative;
  }
  .new-search input#search {
    width: 40px;
    height: 40px;
    font-size: 14px;
    float: right;
    padding-left: 40px;
    border-radius: 5px;
    color: #262626;
    border: 1px solid transparent;
    transition: width .55s ease;
  }
  .new-search .icon{
    position: absolute;
    top: 50%;
    font-size: 22px;
    margin-top: 8px;
    z-index: 1;
    color: #4f5b66;
    right: 15px;
  }

  .new-search input#search:focus,
  .new-search input#search:active {
    outline: none;
    width: 210px;
    padding-left: 15px;
    background: #eee;
  }

  .new-search:hover input#search,
  .new-search input#search:focus {
    width: 279px;
    padding-left: 15px;
    /* background: #eee; */
  }

  .exclusive .search input#search {
    padding-left: 50px;
  }
  .right-content {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-right: 10px;
  }

  .navbar-nav .nav-link {
    position: relative;
  }

  .nav-item.dropdown:not(.iconlink) .nav-link:before {
    display: block;
    position: absolute;
    right: 0px;
    font: normal normal normal 14px/1.5 FontAwesome;
    font-size: 15px;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    content: "\F107";
  }

  .track-hover .hover-label {
    display: none;
    font-size: 8px;
    color: #333;
    margin-top: 4px;
    text-align: center;
  }

  .track-hover:hover .hover-label {
    display: block;
    position: relative;
    margin-top: 0;
  }

  .navicon a.dropdown-toggle,
  .navicon .noTdropdown {
    padding: 0 !important;
    margin: 0;
    width: 50px;
    text-align: center;
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
  }

  .navicon a.dropdown-toggle .bagIcon {
    width: 24px;
    image-rendering: auto;
  }

  .navicon a .dropdown-menu {
    padding: 15px !important;
  }

  .navicon .dropdown-menu a {
    font-size: 15px !important;
  }

  .dropdown-menu.right {
    right: 0;
    left: inherit;
  }

  .dropdown-menu {
    padding: .5rem 0 0.4rem;
  }

  .dropdown-item.profile{
    cursor: pointer;
    color: #58595b !important;
  }

  .dropdown-item.profile:hover, .dropdown-item.profile.profileactive{
    color: #ed2d2f !important;
  }

  .dropdown-item.active,
  .dropdown-item:active,
  .dropdown-item:focus,
  .dropdown-item:hover {
    background-color: transparent;
  }


  .headerRight .hicon{
    font-size: 24px;
  }

  @media screen and (max-width: 1200px) {
    .topbar {
      min-height: 53px
    }

    .navbar-toggleable-md .navbar-nav .nav-link {
      padding-right: .8rem;
      padding-left: .8rem;
      font-size: 14px;
    }

    .mobilesearch {
      width: 300px;
      margin-right: 8em;
    }

    .new-search:hover input#search,
    .new-search input#search:focus {
      width: 210px;
      padding-left: 15px;
      /* background: #eee; */
    }
  }
  @media screen and (max-width: 1492px) {
    .navbar-toggleable-md .navbar-collapse {
      /*width: 67%;*/
    }
  }
  @media screen and (max-width: 1184px) {
    .navbar-toggleable-md .navbar-collapse {
      /*width: 62%;*/
    }
  }
  @media screen and (max-width: 1200px) {

    .topbar {
      min-height: 53px
    }

    .navbar-toggleable-md .navbar-nav .nav-link {
      padding-right: .8rem;
      padding-left: .8rem;
      font-size: 14px;
    }

    .mobilesearch {
      width: 300px;
      margin-right: 8em;
    }
  }
  @media screen and (max-width: 991px) {
    .navbar-nav {
      padding-bottom: 80px;
    }
    .navbar-toggleable-md .navbar-nav .nav-link {
      margin-left: 0;
    }
    .dropdown-item.citem {
      font-size: 15px;
      padding: 0px 30px;
      line-height: 28px;
    }
  }
  @media (min-width: 1920px) {
  .custom-container{
    min-width: 1920px; 
    margin: 0 auto;
  }
}


</style>
<style>
.navbar-nav .nav-item .nav-link {
  color: #3E3F45;
}
.exclusive .headerRight .nav-item a .count {
  right: 3px;
  top: 9px !important;
}
</style>



// WEBPACK FOOTER //
// newAppNav.vue?1120add3